import React from 'react';

export const useSetDirection = (locale?: string) => {
	React.useEffect(() => {
		document.documentElement.dir = 'ltr';
	}, [locale]);
};
